import React from 'react';
import {
    FETCH_SLA_REQUEST,
    FETCH_SLA_REQUEST_SUCCESS,
    FETCH_SLA_REQUEST_FAILER,
    CREATE_SLA_REQUEST,
    CREATE_SLA_REQUEST_SUCCESS,
    CREATE_SLA_REQUEST_FAILER
} from './SlaActionTypes';
import { IAction } from './ISlaAction';

// FETCH ACTIONS
export const fetchSlaRequest = (): IAction => {
    return {
        type: FETCH_SLA_REQUEST
    }
}

export const fetchSlaRequestSuccess = (data: any): IAction => {
    return {
        type: FETCH_SLA_REQUEST_SUCCESS,
        payload: data
    };
}

export const fetchSlaRequestFailer = (errorMsg: any): IAction => {
    return {
        type: FETCH_SLA_REQUEST_FAILER,
        payload: errorMsg
    };
}

// CREATE ACTIONS
export const createSlaRequest = (): IAction => {
    return {
        type: CREATE_SLA_REQUEST
    }
}

export const createSlaRequestSuccess = (data: any): IAction => {
    return {
        type: CREATE_SLA_REQUEST_SUCCESS,
        payload: data
    };
}

export const createSlaRequestFailer = (errorMsg: any): IAction => {
    return {
        type: CREATE_SLA_REQUEST_FAILER,
        payload: errorMsg
    };
}